import { useEffect } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";
import { isSyntheticEvent } from "../lib/isSyntheticEvent";
import { navigate, routes } from "../lib/urls";

const chords: Record<string, Record<string, () => void>> = {
  g: {
    r: () => navigate(routes.recents),
    f: () => navigate(routes.favorites),
    c: () => navigate(routes.chats),
    p: () => navigate(routes.personal),
    l: () => navigate(routes.links),
    o: () => navigate(routes.connectors),
    k: () => navigate(routes.skills),
    m: () => navigate(routes.monitoring),
    s: () => navigate(routes.settings),
    "1": () => navigate(routes.settings.featureFlags),
  },
};

export function useChordShortcuts() {
  useEffect(() => {
    let leader: string | null = null;
    let timer: ReturnType<typeof setTimeout> | null = null;

    function reset() {
      leader = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function handleKeyDown(e: KeyboardEvent) {
      if (isSyntheticEvent(e)) return;
      if (isEditableTarget(e)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const key = e.key.toLowerCase();

      if (leader) {
        const action = chords[leader]?.[key];
        reset();
        if (action) {
          e.preventDefault();
          action();
        }
        return;
      }

      if (chords[key]) {
        leader = key;
        timer = setTimeout(reset, 1500);
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      reset();
    };
  }, []);
}
